import gql from "graphql-tag";

export const LOAD_OUT_TIME_QUERY = gql`
  query loadOutTimeValues {
    loadOutTimeValues {
      key
      value
	  }
  }
`;